<template>
  <v-card>
    <v-card-text>
      <v-timeline v-if="assignments && assignments.length > 0" dense>
        <v-timeline-item
          v-for="(assignment, index) in sortedAssignments"
          :key="assignment._id"
        >
          <template v-slot:icon>
            <avatar-broker
              size="40"
              :src="getBrokerInfo(assignment.broker_id).image"
              :alt="getBrokerInfo(assignment.broker_id).name"
            />
          </template>
          <card-assignment
            :assignedDate="formatDateTime(assignment.assigned_at)"
            :reviewedDate="
              assignment.reviewed_at && formatDateTime(assignment.reviewed_at)
            "
            :elapsedTime="
              assignment.reviewed_at && getAttentionTime(assignment)
            "
            :brokerName="getBrokerInfo(assignment.broker_id).name"
            :isActive="index === 0 && assignment.status === 'active'"
            :callsCount="getAssignmentCalls(assignment, index).length"
          />
          <broker-calls-list :calls="getAssignmentCalls(assignment, index)" />
        </v-timeline-item>
      </v-timeline>

      <v-alert v-else type="info" outlined text class="ma-0">
        <div class="d-flex align-center">
          No hay historial de asignaciones disponible
        </div>
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { GetLeadRingoverHistory } from "@/api/lead-api";

export default {
  name: "AssignmentHistory",
  components: {
    AvatarBroker: () => import("@/components/lead/components/avatarBroker.vue"),
    CardAssignment: () =>
      import(
        "@/components/lead/components/assignmentHistory/CardAssignment.vue"
      ),
    BrokerCallsList: () =>
      import(
        "@/components/lead/components/assignmentHistory/BrokerCallsList.vue"
      )
  },
  props: {
    lead: {
      type: Object,
      required: true
    },
    brokers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ringoverHistory: []
    };
  },
  computed: {
    assignments() {
      return this.lead?.assignments_history || [];
    },
    sortedAssignments() {
      return [...this.assignments].sort(
        (a, b) => new Date(b.assigned_at) - new Date(a.assigned_at)
      );
    }
  },
  created() {
    if (this.lead?._id) {
      GetLeadRingoverHistory(this.lead._id)
        .then(calls => {
          this.ringoverHistory = calls;
        })
        .catch(() => {
          this.ringoverHistory = [];
        });
    }
  },
  methods: {
    getAssignmentCalls(assignment, index) {
      const start = new Date(assignment.assigned_at);
      const previousAssignment = this.sortedAssignments[index - 1];
      const end = previousAssignment
        ? new Date(previousAssignment.assigned_at)
        : null;

      return this.ringoverHistory.filter(call => {
        if (call.broker_id !== assignment.broker_id) return false;
        const callDate = new Date(call.created_at);
        return callDate >= start && (!end || callDate < end);
      });
    },
    getBrokerInfo(brokerId) {
      const broker = this.brokers.find(b => b._id === brokerId);
      return {
        name: broker?.name || "Usuario no encontrado",
        image: broker?.media?.featured_image?.src || null
      };
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    getAttentionTime(assignment) {
      if (!assignment.reviewed_at) return "Pendiente";

      const assignedTime = moment(assignment.assigned_at);
      const reviewedTime = moment(assignment.reviewed_at);
      const duration = moment.duration(reviewedTime.diff(assignedTime));

      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();

      let timeText = "";
      if (days > 0) timeText += `${days}d `;
      if (hours > 0) timeText += `${hours}h `;
      if (minutes > 0) timeText += `${minutes}min`;

      return timeText.trim() || "Menos de 1min";
    }
  }
};
</script>

<style scoped>
.v-timeline-item__dot {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.caption {
  line-height: 1.2;
}
</style>
